import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { aviApi } from "@/lib/aviApi";
import { BrandMark } from "@/components/BrandMark";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(location.hash.slice(1));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        if (!sessionId) throw new Error("missing session");
        await aviApi.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      } catch (e) {
        navigate("/welcome?auth=failed", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="consumer min-h-screen grid place-items-center avi-warmth" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3">
        <BrandMark className="h-12 w-12" />
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
